import n from "../../../@babel/runtime/helpers/esm/objectSpread22.mjs";
import S from "../../../@babel/runtime/helpers/esm/typeof2.mjs";
var v = "add", g = "keep", y = "remove", b = "removed";
function T(a) {
  var o;
  return a && S(a) === "object" && "key" in a ? o = a : o = {
    key: a
  }, n(n({}, o), {}, {
    key: String(o.key)
  });
}
function k() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return a.map(T);
}
function A() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], t = [], u = 0, m = o.length, p = k(a), f = k(o);
  p.forEach(function(e) {
    for (var r = !1, s = u; s < m; s += 1) {
      var c = f[s];
      if (c.key === e.key) {
        u < s && (t = t.concat(f.slice(u, s).map(function(h) {
          return n(n({}, h), {}, {
            status: v
          });
        })), u = s), t.push(n(n({}, c), {}, {
          status: g
        })), u += 1, r = !0;
        break;
      }
    }
    r || t.push(n(n({}, e), {}, {
      status: y
    }));
  }), u < m && (t = t.concat(f.slice(u).map(function(e) {
    return n(n({}, e), {}, {
      status: v
    });
  })));
  var i = {};
  t.forEach(function(e) {
    var r = e.key;
    i[r] = (i[r] || 0) + 1;
  });
  var E = Object.keys(i).filter(function(e) {
    return i[e] > 1;
  });
  return E.forEach(function(e) {
    t = t.filter(function(r) {
      var s = r.key, c = r.status;
      return s !== e || c !== y;
    }), t.forEach(function(r) {
      r.key === e && (r.status = g);
    });
  }), t;
}
export {
  v as STATUS_ADD,
  g as STATUS_KEEP,
  y as STATUS_REMOVE,
  b as STATUS_REMOVED,
  A as diffKeys,
  k as parseKeys,
  T as wrapKeyToObject
};
//# sourceMappingURL=diff.mjs.map
